import { DatePicker } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

const { RangePicker } = DatePicker;

export const StyledRangePicker = styled(RangePicker)`
  width: 100%;

  .ant-picker-suffix,
  .ant-picker-suffix .anticon,
  .ant-picker-range-separator,
  .ant-picker-range-separator .anticon {
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.85) !important;
  }

  .ant-picker-suffix .anticon svg,
  .ant-picker-range-separator .anticon svg {
    fill: currentColor;
  }
`;
